var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaybook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PLAYBOOK") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLAYBOOK",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_playbook_2371044-copy",
    transform: "translate(0.500000, 0.500000)",
    fill: "#1F8C21",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4872662,0.0144043033 C11.3427209,0.0144043033 11.1954484,0.0144043033 11.0454486,0.0144043033 C8.92636017,0.000768815761 7.13181684,0.696178682 6.27272695,1.73247574 C5.28000085,0.546188319 3.04636714,-0.217398985 0.488188352,0.055310766 L0.488188352,0.055310766 C0.210546892,0.0846232749 -0.000140230534,0.318836088 3.53352556e-06,0.598003171 L3.53352556e-06,9.57288109 C-0.000546931893,9.72593809 0.0632399385,9.87218473 0.175794089,9.97591474 C0.28834824,10.0796447 0.439310981,10.1313115 0.591824593,10.1183006 L0.591824593,10.1183006 C0.788187997,10.0910296 1.00091502,10.0910296 1.22727839,10.0910296 C3.40909398,10.0910296 4.94454671,10.9091589 5.34272805,11.7000171 L5.34272805,11.7000171 C5.43559762,11.8843069 5.62453198,12.0004045 5.83090929,12 L6.16909071,12 C6.37546802,12.0004045 6.56440238,11.8843069 6.65727195,11.7000171 L6.65727195,11.7000171 C7.05545329,10.9091589 8.59908783,10.0910296 10.7727216,10.0910296 C10.999085,10.0910296 11.211812,10.0910296 11.4081754,10.1155735 L11.4081754,10.1155735 C11.560689,10.1285844 11.7116518,10.0769176 11.8242059,9.97318764 C11.9367601,9.86945763 12.0005469,9.72321099 12.0000035,9.57015399 L12.0000035,0.546188319 C12.0005134,0.257292015 11.7756607,0.0181021533 11.4872662,0.000768815761 L11.4872662,0.0144043033 Z M4.3636383,8.59930728 L4.3636383,3.40145942 L8.69726953,6.00038335 L4.3636383,8.59930728 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybook);
export default __webpack_public_path__ + "static/media/playbook.7c366e6c357153c63d33ac11a6e21e20.svg";
export { ForwardRef as ReactComponent };